import qs from 'qs'
import request from '../utils/request'
import { commonConfig } from '../utils/config'
const { apiHetaoDomain } = commonConfig

/**
 * 公益课-学校报表
 * @author Awen_liang1002
 * @date 2023-04-19
 * @param {any} params
 * @returns {any}
 */
export async function apiGetB2CSchoolTable(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/schools/forms`, {
    type: 'POST',
    params
  })
}

/**
 * 公益课-学校报表-下载
 * @author Awen_liang1002
 * @date 2023-04-19
 * @param {any} params
 * @returns {any}
 */
export async function apiDownloadB2CSchoolTable(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/schools/forms/download`, {
    type: 'POST',
    params
  })
}

/**
 * 公益课-班级报表-下载
 * @author Awen_liang1002
 * @date 2023-04-19
 * @param {any} params
 * @returns {any}
 */
export async function apiDownloadB2CClassTable(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/classes/forms/download`, {
    type: 'POST',
    params
  })
}

/**
 * 公益课-班级报表
 * @author Awen_liang1002
 * @date 2023-04-19
 * @param {any} params
 * @returns {any}
 */
export async function apiGetB2CClassTable(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/classes/forms`, {
    type: 'POST',
    params
  })
}

/**
 * 公益课学期列表
 * @author Awen_liang1002
 * @date 2023-05-04
 * @returns {any}
 */
export async function apiGetB2CTermsList() {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/terms`)
}

/**
 * 公益课学校列表
 * @author Awen_liang1002
 * @date 2023-05-04
 * @returns {any}
 */
export async function apiGetB2CSchoolsList() {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/schools`)
}

/**
 * 公益课年级列表
 * @author Awen_liang1002
 * @date 2023-05-04
 * @returns {any}
 */
export async function apiGetB2CGradesList() {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/grades`)
}

/**
 * 公益课班级列表
 * @author Awen_liang1002
 * @date 2023-05-04
 * @returns {any}
 */
export async function apiGetB2CClassesList() {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/classes`)
}

/**
 * 全链路数据合计
 */
export async function apiGetB2CTermSum(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/mobile/btoc/terms/sum?`,
    {
      type: 'POST',
      params
    }
  )
}

/**
 * 全链路数据列表
 */
export async function apiGetB2CTermList(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/mobile/btoc/term/formOffline`,
    {
      type: 'POST',
      params
    }
  )
}

/**
 * 公益课实时合计
 */

export async function apiGetB2CTermRealSum(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/mobile/btoc/term/sumOnline`, {
    type: 'POST',
    params
  })
}

/**
 * 公益课实时列表
 */

export async function apiGetB2CTermRealList(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/mobile/btoc/public/class/form/pc`, {
    type: 'POST',
    params
  })
}

/**
 * 学期列表
 */
export async function apiGetB2CTerms(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/mobile/btoc/terms?${qs.stringify(params)}`)
}

/**
 * 学校列表
 */
export async function apiGetB2CSchools(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/mobile/btoc/schools`, {
    type: 'POST',
    params
  })
}

/**
 * 年级列表
 */
export async function apiGetB2CGrades() {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/grades`)
}

/**
 * 班级列表
 */
export async function apiGetB2CClasses() {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/classes`)
}

/**
 * 全链路数据下载
 */
export async function apiDownloadB2CSfullLinkTable(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/mobile/btoc/term/formOffline/download`, {
    type: 'POST',
    params
  })
}

/**
 * 实时数据下载
 */
export async function apiDownloadB2CSRealTimeTable(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/mobile/btoc/public/class/form/download`, {
    type: 'POST',
    params
  })
}

/**
 * 班级列表
 */
export async function apiGetB2CClassList() {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/public-welfare/classes`)
}

/**
 * 全链路数据合计 - 校园合作项目
 */
export async function apiGetCampusTermSum(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/mobile/btoc/pc/terms/sum?`,
    {
      type: 'POST',
      params
    }
  )
}

/**
 * 全链路数据列表 - 校园合作项目
 */
export async function apiGetCampusTermList(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/mobile/btoc/pc/term/formOffline`,
    {
      type: 'POST',
      params
    }
  )
}

/**
 * 公益课实时合计 - 校园合作项目
 */
export async function apiGetCampusTermRealSum(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/mobile/btoc/pc/term/sumOnline`, {
    type: 'POST',
    params
  })
}

/**
 * 公益课实时列表 - 校园合作项目
 */
export async function apiGetCampusTermRealList(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/mobile/btoc/pc/public/class/form/pc`, {
    type: 'POST',
    params
  })
}

/**
 * 全链路数据下载 - 校园合作项目
 */
export async function apiDownloadCampusSfullLinkTable(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/mobile/btoc/pc/term/formOffline/download`, {
    type: 'POST',
    params
  })
}

/**
 * 实时数据下载 - 校园合作项目
 */
export async function apiDownloadCampusSRealTimeTable(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/mobile/btoc/pc/public/class/form/download`, {
    type: 'POST',
    params
  })
}
